<template>
  <div class="compressed-content">
    <h3>What was your last total coronary artery calcium (CAC) score?</h3>
    <v-form-group class="page-buttons" :validator="$v.score" label="Score">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.arteryBlockages.lastCacTest.obtainedScore"
                    placeholder="0 - 3000" />
    </v-form-group>
    <h3 class="mt-5 mb-3">How old were you when you took this assessment?</h3>
    <v-form-group class="page-buttons" :validator="$v.age" label="Age">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.arteryBlockages.lastCacTest.doneAtAge"
                    placeholder="18 - 90" />
    </v-form-group>
    <h3 class="mt-5">Was your CAC score higher than ANY previous assessments?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isProgression">
      <b-form-radio v-model="survey.arteryBlockages.lastCacTest.isProgression" name="progress" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastCacTest.isProgression" name="progress" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric, decimal } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      score: {
        required,
        between: between(0, 3000),
        decimal
      },
      age: {
        required,
        between: between(18, 90),
        numeric
      },
      isProgression: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      score() { return this.survey.arteryBlockages.lastCacTest.obtainedScore; },
      age() { return this.survey.arteryBlockages.lastCacTest.doneAtAge; },
      isProgression() { return this.survey.arteryBlockages.lastCacTest.isProgression; }
    }
  };
</script>